import { render } from "./index.vue?vue&type=template&id=579cb6b4"
const script = {}

import "./testimonials.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__